import { render, staticRenderFns } from "./QuestionModal.vue?vue&type=template&id=047d554e"
import script from "./QuestionModal.vue?vue&type=script&lang=js"
export * from "./QuestionModal.vue?vue&type=script&lang=js"
import style0 from "./QuestionModal.vue?vue&type=style&index=0&id=047d554e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports